import {writable} from 'svelte/store';


let shiftObject = {
    id: 0,
    duration: '',
};

const {get, set, update, subscribe} = writable(shiftObject);

const shift$ = {
    set,
    update,
    subscribe,

    setShift: data => {
        if (!data) {
            return;
        }

        shift$.update(obj => {
            obj.id = data.id;
            obj.driver = data.driver;
            obj.vehicle = data.vehicle;
            obj.start_at = new Date(data.start_at);
            obj.end_at = null;
            obj.duration = new Date() - obj.start_at;

            return obj;
        });
    },

    setDuration: () => {
        if (shiftObject?.id > 0) {
            shift$.update(obj => {
                obj.duration = new Date() - obj.start_at;
                return obj;
            });
        }
    },

    clear: () => {
        shift$.update(obj => {
            obj.id = 0;
            obj.driver = null;
            obj.vehicle = null;
            obj.start_at = null;
            obj.end_at = null;
            obj.duration = '';

            return obj;
        });
    },
}

export default shift$;